import type { WidgetTriggerPathType } from '@/common/utils/types';
import { CardNodeAlert, CardNodeStatus, CardNodeType } from './types';

// Constants
export const NODE_TYPES = {
  GROUP: 'group',
  WRAPPER: 'wrapper',
  CARD: 'card',
  PLACEHOLDER: 'placeholder',
} as const;

export const NODE_STATUS: Record<string, CardNodeStatus> = {
  UNKNOWN: 'unknown',
  ON: 'on',
  OFF: 'off',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  // Primary
  UP: 'up',
  DOWN: 'down',
  STARTED: 'started',
  // Replica
  STREAMING: 'streaming',
  STARTUP: 'startup',
  CATCHUP: 'catchup',
  BACKUP: 'backup',
  STOPPING: 'stopping',
};

export const ALERT_LEVELS: Record<string, CardNodeAlert> = {
  NORMAL: 'normal',
  WARNING: 'warning',
  CRITICAL: 'critical',
} as const;

export const DEFAULT_GROUP = {
  NAME: 'Cubrid',
  ICON: 'icon-cubrid',
} as const;

export const KAFKA_GROUP = {
  NAME: 'Kafka',
  ICON: 'icon-kafka-mono',
} as const;

export const BROKER_CONFIG = {
  TITLE: 'Cubrid Broker',
  ICON: 'icon-broker',
  TYPE: 'cubrid_broker',
} as const;

export const DB_CONFIG = {
  TITLE: 'Cubrid Database',
  ICON: 'icon-cubrid',
  TYPE: 'cubrid_database',
} as const;

export const KAFKA_BROKER_CONFIG = {
  TITLE: 'Kafka Broker',
  ICON: 'icon-kafka-mono', // active controller ? 'icon-active-controller' : 'icon-kafka-mono'
  TYPE: 'kafka_broker',
} as const;

export const CUBRID_BROKER_WRAPPER_CONFIG = {
  TITLE: 'Broker Nodes',
  ICON: 'icon-broker',
} as const;

export const CUBRID_WRAPPER_CONFIG = {
  TITLE: 'DB Nodes',
  ICON: 'icon-database',
} as const;

export const KAFKA_BROKER_WRAPPER_CONFIG = {
  TITLE: 'Broker Nodes',
  ICON: undefined,
} as const;

export const KAFKA_CLUSTER_WRAPPER_CONFIG = {
  TITLE: 'Kafka Cluster',
  ICON: 'icon-kafka-mono', // attribute === 'zookeeper' ? icon-zookeeper : icon-kafka-mono
  TYPE: 'kafka_cluster',
} as const;

export const KAFKA_VIEW_GROUP_ID = 'kafka_cluster' as const;

// 계층별 레이아웃 카테고리
export const LAYOUT_CATEGORY = {
  // GROUP 레벨 (자식 Wrapper 배치)
  KAFKA_GROUP: 'kafka_group', // ClusterWrapper들 그리드 배치
  CUBRID_GROUP: 'cubrid_group', // Wrapper들 수직 배치

  // CLUSTER_WRAPPER 레벨 (Primary 상단 + 자식 수직)
  CLUSTER_WITH_PRIMARY: 'cluster_with_primary', // Primary 노드 상단 + 하위 Wrapper 수직

  // WRAPPER 레벨 (자식 Card 배치)
  CARD_HORIZONTAL: 'card_horizontal', // Card들 가로 배치
} as const;

export type LayoutCategory = (typeof LAYOUT_CATEGORY)[keyof typeof LAYOUT_CATEGORY];

// PostgreSQL HA
export const PG_REPLICATION_GROUP = {
  NAME: 'PostgreSQL',
  ICON: 'icon-postgresql',
} as const;

export const PG_PRIMARY_CONFIG = {
  TITLE: 'Primary',
  ICON: 'icon-postgresql-primary',
  TYPE: 'postgresql_replication_primary',
} as const;

export const PG_STANDBY_CONFIG = {
  TITLE: 'Standby',
  ICON: 'icon-postgresql-standby',
  TYPE: 'postgresql_replication_standby',
} as const;

export const PG_PRIMARY_WRAPPER_CONFIG = {
  TITLE: 'Primary',
  ICON: undefined,
} as const;

export const PG_STANDBY_WRAPPER_CONFIG = {
  TITLE: 'Replica',
  ICON: undefined,
} as const;

// 카드 노드 클릭 시 연계할 target detail triggerPath (WidgetTriggerPathType)
export const TRIGGER_PATH_BY_NODE: Partial<Record<CardNodeType, WidgetTriggerPathType>> = {
  cubrid_broker: 'cubridBrokerInfo',
  cubrid_database: 'dbInfo',
  kafka_broker: 'kafkaBrokerInfo',
  kafka_cluster: 'kafkaClusterInfo',
  postgresql_replication_primary: 'dbInfo',
  postgresql_replication_standby: 'dbInfo',
};

// 카드 노드 클릭 시 target detail 슬라이드에서 기본 선택할 탭 값
export const SELECTED_TAB_BY_NODE: Partial<Record<CardNodeType, string>> = {
  postgresql_replication_primary: 'ha',
  postgresql_replication_standby: 'ha',
};
